import { render } from "./OldRegistre.vue?vue&type=template&id=275536f5"
import script from "./OldRegistre.vue?vue&type=script&lang=js"
export * from "./OldRegistre.vue?vue&type=script&lang=js"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__